/// <reference path="../public/jquery-1.6.2.min.js" />
/// <reference path="../public/AJAX.js" />
/// <reference path="../public/General.js" />
/// <reference path="../public/Security.js" />
/// <reference path="../public/ServiceURL.js" />
/// <reference path="../SumoDataAccess.js" />
/// <reference path="../SumoClass.js" /> 

// generalized code to render template controls
// constructor params:
// aRootPath: the root path to the control template
// aControlName: the name of the control - this will be added to the root 
//               path as a sub directory and is the basis for the control file names too
// aOnLoadCallback: the callback called after the control has been loaded

// load() params
// aElementId: the id of the html dom elment to create
// aParentElementId: the id of the html dom element into which the new control will be inserted
// aConstructorOptions: any Options that must be passed to the constructor of the control
/**
 * @param  {} aRootPath
 * @param  {} aControlName
 * @param  {} aOnLoadCallback
 * @param  {String} inlineHtml This option will bypass loading the html file
 * Rightnow is only used by FilterControl.js
 * @example
 * gFilterFactory = new SumoControlFactory(
        'Scripts/Controls/',
        'FilterControl',
        null, 
        baseHtml.join(''));
 */
//heavily use for FilterControl.js
function SumoControlFactory(aRootPath,
                           aControlName,
                           aOnLoadCallback,inlineHtml) {
    "use strict";

    SumoControlFactory.prototype.baseClass.call(this);

    if (this.isNothing($)) {
        throw (this.className() + ' requires jquery-1.6.2.*.js');
    }

    var mFilesLoading = 0,
        mIsInitialized = false,
        mControlTemplateHtml = null;

    this.Controls = [];
    this.RootPath = aRootPath;
    this.ControlName = aControlName;
    this.HtmlFileName = this.ControlName + '.htm';
    this.ScriptFileName = this.ControlName + '.js';
    this.StyleFileName = this.ControlName + '.css';
    
    if (!this.isNothing(aOnLoadCallback)) {
        this.bind('templateloaded', aOnLoadCallback, null); 
    }

    this.createControl = function (aElementId, aParentElementId, aConstructorOptions) {
        if (!mIsInitialized) {
            throw (this.className() + ': ' + this.ControlName + ' is not initialized.');
        }
        if ($('#' + aElementId).length > 0) {
            throw (this.className() + ': element already exists in dom: ' + aElementId);
        }
        //        if ($('#' + aParentElementId).length === 0) {
        //            throw (this.className() + ': parent element does not exist in dom: ' + aParentElementId);
        //        }

        var lControl = new window[this.ControlName](
            aElementId,
            aParentElementId,
            mControlTemplateHtml,
            aConstructorOptions);
        if (this.isNothing(lControl)) {
            throw (this.className() + ': instantiateControl failed for: ' + this.ControlName + ", id: " + aElementId);
        }
        this.Controls[aElementId] = lControl;
        if (!this.isNothing(aParentElementId)) {
            lControl.render();
        }
        return lControl;
    };

    function onFileLoadComplete(aThis, aElementId, aParentElementId, aConstructorOptions) {
        --mFilesLoading;
        if (mFilesLoading === 0) {
            mIsInitialized = true;
            aThis.trigger('templateloaded', aThis.ControlName);
        }
    }
    function loadInlineTemplate(aThis){
        ++mFilesLoading;
        mControlTemplateHtml = inlineHtml;
        onFileLoadComplete(aThis);
    }
    function loadControlTemplate(aThis) {
        ++mFilesLoading;
        $.get(aThis.RootPath + aThis.ControlName + '/' + aThis.HtmlFileName,
            function (responseText, textStatus, XMLHttpRequest) {
                mControlTemplateHtml = responseText;
                onFileLoadComplete(aThis);
            });
    }

    function loadScript(aThis) {
        // only load the script if it hasn't been loaded
        // we can check this by examining the global namespace for 
        // the control's constructor function
        if (aThis.isNothing(window[aThis.ControlName])) {
            ++mFilesLoading;
            $.getScript(aThis.RootPath + aThis.ControlName + '/' + aThis.ScriptFileName,
                function (data, textStatus) {
                    onFileLoadComplete(aThis);
                }
            );
        }
    }

    function loadCss(aThis) {
        var lCssSource = aThis.RootPath + aThis.ControlName + '/' + aThis.StyleFileName;
        $('<link/>', {
                rel: 'stylesheet',
                type: 'text/css',
                href: lCssSource
            }).appendTo('head');
        // leaving comment here because it's a good way to show if CSS is loaded
        //            lIsCssLoaded = $('link[href="' + lCssSource + '"]').length > 0;
        //        if (!lIsCssLoaded) {
        //}
    }

    function load(aThis) {
        if (!mIsInitialized) {
            mFilesLoading = 0;
            loadScript(aThis);
            if(inlineHtml){
                loadInlineTemplate(aThis);
            }else {
                loadCss(aThis);
                loadControlTemplate(aThis);
            }
            
        }
    }

    load(this);
}

SumoControlFactory.prototype = new sumo.Class();
SumoControlFactory.prototype.constructor = SumoControlFactory;
SumoControlFactory.prototype.baseClass = sumo.Class;

